import MicroModal from 'micromodal';

export default function zipCodeLookUp() {
  const
    protocol = window.location.protocol + "//",
    base_url = window.location.hostname,
    zips_rest_endpoint = "/export/county-zipcodes",
    zipcode_api= protocol + base_url + zips_rest_endpoint
  ;

  const zipCodeField = document.querySelectorAll('[name=question_home_location_zipcode]')[0];
  const nextButton = document.getElementById('edit-actions-wizard-next');

  let zips = [];

  MicroModal.init({
    onShow: modal => console.info(`${modal.id} is shown`),
    onClose: modal => console.info(`${modal.id} is hidden`),
    openTrigger: "data-custom-open",
    closeTrigger: "data-custom-close",
    openClass: "is-open",
    disableScroll: true,
    disableFocus: false,
    awaitOpenAnimation: false,
    awaitCloseAnimation: false,
    debugMode: true
  });

  let promise =
    fetch(zipcode_api)
      .then( response => response.json() )
      .then(data => {

        if (zipCodeField && nextButton) {

          zips = data.map(function (item) {
            return item.field_zipcodes_county;
          });

          zipCodeField.addEventListener('keyup', function () { //focusout
            zipCodeValidate(zips, this.value.replaceAll('_', ''), nextButton);
          });

          nextButton.addEventListener('mousedown', function() {
            zipCodeValidate(zips, zipCodeField.value.replaceAll('_', ''), nextButton)
          })
        }
      })
}

export function zipCodeValidate(zip_list, zip_input, submit_btn) {
  let zip_check = false;

  zip_list.some(function (item) {
    if (item.includes(zip_input)) {
      zip_check = true;
      return true;
    }
  })

  if (!zip_check && zip_input.length === 5) {
    submit_btn.classList.add('btn-disabled');
    submit_btn.disabled = true;
    MicroModal.show('modal-zipcode-alert');
  } else {
    submit_btn.classList.remove('btn-disabled');
    submit_btn.disabled = false;
  }
}
